<template>
  <div>
    <div class="mb-3">
      <div v-if="question.content" v-html="question.content" class="question__content"></div>
    </div>

    <template v-if="editable">
      <b-form-input v-on:change="inputAnswer" placeholder="Enter your choice"></b-form-input>
    </template>
    <template v-else>
      <b-form-input class="mb-1" :state="isCorrect" :value="response.answer" readonly></b-form-input>
      <template v-if="!isCorrect">
        <div
          v-for="answer in question.answers"
          :key="answer.id"
        >
          <template v-if="response.answer != answer.content">
            <b-form-input :state="true" :value="answer.content" readonly></b-form-input>
          </template>
        </div>
      </template>

      <div class="exam__part__title" v-if="response.comment">Hướng dẫn làm bài</div>

      <b-form-textarea
        v-if="response.comment"
        id="textarea-comment"
        :value="response.comment"
        readonly
        rows="5"
        max-rows="5"
        class="mt-1"
      ></b-form-textarea>
    </template>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionWritingSort',
  props: {
    question: Object,
    editable: Boolean,
    response: Object
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      isSelected: false,
      isCorrect: false,
      answer: []
    }
  },
  methods: {
    inputAnswer(evt) {
      this.$emit('selectAnswer', {
        question_id: this.question.id,
        answer: evt
      })
    },
  },
  mounted() {
    if (!this.editable) {
      const isCorrect = this.question.answers.find((answer) => answer.content == this.response.answer);

      if (isCorrect) {
        this.isCorrect = true;
      }
    }
  }
}
</script>